module.exports = __webpack_public_path__ + "img/up.a86138cb.svg";